var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{style:(_vm.buttonStyle),attrs:{"variant":_vm.variant,"size":_vm.size,"type":_vm.type,"disabled":_vm.loading || _vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm mr-2"}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }